import { call, put, takeEvery } from 'redux-saga/effects';
import PermissionService from '../../services/PermissionService';
import {
  CURRENT_USER_PERMISSIONS_REQUEST,
  USER_ROLES_REQUEST,
} from './actionTypes';
import {
  currentUserPermissionsSuccess,
  currentUserPermissionsFailure,
  userRolesSuccess,
  userRolesFailure,
} from './actions';

export function* getCurrentUserPermissions() {
  try {
    const permissions = yield call(PermissionService.getCurrentUserPermissions);
    yield put(currentUserPermissionsSuccess(permissions));
  } catch (error) {
    yield put(currentUserPermissionsFailure(error));
  }
}

export function* getRoles() {
  try {
    const roles = yield call(PermissionService.getRoles);
    yield put(userRolesSuccess(roles));
  } catch (error) {
    yield put(userRolesFailure(error));
  }
}

export function* permissionsSaga() {
  yield takeEvery(CURRENT_USER_PERMISSIONS_REQUEST, getCurrentUserPermissions);
  yield takeEvery(USER_ROLES_REQUEST, getRoles);
}
